import React, { Component } from "react"
import { Link }             from "react-router-dom"
import "pages/checkout/HeaderCheckout.scss"
import { withRouter }       from "react-router"

@withRouter
class HeaderCheckout extends Component {
	render() {
		const {referer, isRequest, activeStep = 0} = this.props
		return (
			<section className="HeaderCheckout pa2 mb4">
				<div className="container">
					<div className="checkout-steps">
						<div className={`step ${activeStep === 0 && "active"}`}><Link
							to={{
								pathname: "/checkout",
								search  : this.props.location.search
							}}>1. <span className="ttc">{translate( "cart.cart" )}</span> </Link></div>

						<div className={`step ${activeStep === 1 && "active"}`}><Link
							to={
								{
									pathname: "/checkout/delivery/",
									search: this.props.location.search
								}
							}>2. <span className="ttc">{translate( "delivery" )}</span> </Link></div>
						<div className={`step ${activeStep === 2 && "active"}`}><Link
							to={{
								pathname: "/checkout/confirmation/",
								search: this.props.location.search
							}}>3. <span className="ttc">{translate( "confirm" )}</span> </Link></div>
					</div>
				</div>
				

			</section>
		)
	}
}

export default HeaderCheckout



// WEBPACK FOOTER //
// ./src/theme/mags/pages/checkout/HeaderCheckout.js